import { Logo } from 'components/common/Logo/Logo';
import {
	BookCheck,
	BookOpenText,
	Brain,
	FileText,
	LogOut,
	Settings,
	X
} from 'lucide-react';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { RoutesPaths } from 'routes/RoutesPathsEnum';
import { MenuItem } from '../types/types';
import { useTranslation } from 'react-i18next';
import useAuth from 'features/auth/hooks/useAuth';
import { Badge } from 'components/common/Badge/Badge';

export default function MobileMenu({
	isMenuOpen,
	setIsMenuOpen
}: {
	isMenuOpen: boolean;
	setIsMenuOpen: (isOpen: boolean) => void;
}) {
	const auth = useAuth();
	const { t } = useTranslation();

	const mobileMenuItems: MenuItem[] = [
		{
			icon: <BookCheck className='h-4 w-4' />,
			label: t('report.retake_test'),
			href: RoutesPaths.INSTRUCTIONS
		},
		{
			icon: <BookOpenText className='h-4 w-4' />,
			label: t('courses.courses'),
			href: RoutesPaths.COURSES
		},
		{
			icon: <FileText className='h-4 w-4' />,
			label: t('profile.my_reports'),
			href: RoutesPaths.REPORTS
		},
		{
			icon: <Settings className='h-4 w-4' />,
			label: t('profile.settings'),
			href: RoutesPaths.PROFILE_EDIT
		},
		{
			icon: <Brain className='h-4 w-4' />,
			label: t('profile.test_breakdown'),
			href: RoutesPaths.CHAT,
			badge: 'AI talent'
		},
		{
			icon: <LogOut className='h-4 w-4 text-red-600' />,
			label: t('profile.logout'),
			href: RoutesPaths.LOGIN,
			onClick: auth.logout
		}
	];
	return (
		<div
			className={`fixed inset-0 z-50 transform bg-white transition-transform duration-300 ease-in-out md:hidden ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'} `}
		>
			<div className='p-4'>
				{/* Mobile menu header */}
				<div className='mb-8 flex items-center justify-between'>
					<Logo />
					<button
						className='p-2 text-gray-600 hover:text-gray-900'
						onClick={() => setIsMenuOpen(false)}
					>
						<X size={24} />
					</button>
				</div>

				<nav className='flex flex-col space-y-4'>
					{mobileMenuItems.map(item => (
						<NavLink
							key={item.label}
							to={item.href ?? '/'}
							onClick={() => {
								if (item.onClick) item.onClick();
								setIsMenuOpen(false);
							}}
							className={({ isActive }) =>
								`flex items-center justify-between gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors ${
									isActive
										? 'bg-blue-50 text-blue-600'
										: 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
								}`
							}
						>
							<div className='flex items-center gap-3'>
								{item.icon}
								{item.label}
							</div>

							{item.badge && (
								<Badge
									text={item.badge as string}
									variant='blue'
								></Badge>
							)}
						</NavLink>
					))}
				</nav>
			</div>
		</div>
	);
}
